/**
 * Midlife LF Trial LP four-systems — mobile card carousel dots sync.
 */

(function () {
  const CAROUSEL_SELECTOR = "[data-ctr-ml-lf-trial-lp-four-systems-carousel]";
  const TRACK_SELECTOR = "[data-ctr-ml-lf-trial-lp-four-systems-track]";
  const DOT_SELECTOR = "[data-ctr-ml-lf-trial-lp-four-systems-dot]";
  const CARD_SELECTOR = "[data-ctr-ml-lf-trial-lp-four-systems-card]";
  const DESKTOP_MQ = window.matchMedia("(min-width: 1024px)");

  function setActiveDot(dots, index) {
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle("is-active", dotIndex === index);
    });
  }

  function getActiveIndex(track, cards) {
    if (!cards.length) return 0;

    const trackRect = track.getBoundingClientRect();
    const trackCenter = trackRect.left + trackRect.width / 2;
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    cards.forEach((card, index) => {
      const cardRect = card.getBoundingClientRect();
      const cardCenter = cardRect.left + cardRect.width / 2;
      const distance = Math.abs(cardCenter - trackCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function scrollToCard(track, cards, index) {
    const card = cards[index];
    if (!card) return;

    const pad = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
    const cardRect = card.getBoundingClientRect();
    const trackRect = track.getBoundingClientRect();

    track.scrollTo({
      left: track.scrollLeft + (cardRect.left - trackRect.left) - pad,
      behavior: "smooth",
    });
  }

  function initCarousel(root) {
    if (root.dataset.ctrMlLfTrialLpFourSystemsInit === "true") return;
    root.dataset.ctrMlLfTrialLpFourSystemsInit = "true";

    const track = root.querySelector(TRACK_SELECTOR);
    const dots = Array.from(root.querySelectorAll(DOT_SELECTOR));
    const cards = Array.from(root.querySelectorAll(CARD_SELECTOR));

    if (!track || !dots.length || !cards.length) return;

    let scrollRaf = null;

    function updateDots() {
      if (DESKTOP_MQ.matches) return;
      setActiveDot(dots, getActiveIndex(track, cards));
    }

    function onScroll() {
      if (scrollRaf) return;

      scrollRaf = window.requestAnimationFrame(() => {
        scrollRaf = null;
        updateDots();
      });
    }

    track.addEventListener("scroll", onScroll, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        if (DESKTOP_MQ.matches) return;

        const index = Number.parseInt(dot.dataset.index || "0", 10);
        scrollToCard(track, cards, index);
        setActiveDot(dots, index);
      });
    });

    DESKTOP_MQ.addEventListener("change", updateDots);
    updateDots();
  }

  function initAll() {
    document.querySelectorAll(CAROUSEL_SELECTOR).forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll(CAROUSEL_SELECTOR).forEach(initCarousel);
  });
})();

